import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {useMediaQuery} from "react-responsive";
import {SignedOutStyleModal, SignedOutModalHeader} from "./styled";

interface IModalInterface {
    show: boolean;
    setModalShow: (_: boolean) => void;
    message: string;
}

export const SignedOutModal: React.FunctionComponent<IModalInterface> = ({
                                                                             show,
                                                                             setModalShow,
                                                                             message
                                                                         }: IModalInterface) => {
    const [modalSize, setModalSize] = useState<"sm" | "lg" | "xl" | undefined>(
        undefined,
    );
    const isMobile: boolean = useMediaQuery({maxWidth: 767});

    const onClose = (): void => {
        setModalShow(false);
    };

    const onOpenModal = (): void => {
        setModalSize(undefined);
    };

    return (
        <SignedOutStyleModal show={show}
                             onHide={onClose}
                             onEnter={onOpenModal}
                             aria-labelledby="contained-modal-title-vcenter"
                             backdrop="static"
                             keyboard={false}
                             fullscreen={isMobile}
                             className={isMobile ? "mobile-css" : "desktop-css"}
                             centered>
            <div className="top-modal-border"></div>
            <Modal.Header closeButton></Modal.Header>
            <SignedOutModalHeader
                className={isMobile ? "mobile-header-css" : "desktop-header-css"}
            >
                <h5>
                    <b>{message}</b>
                </h5>
            </SignedOutModalHeader>
            <Modal.Body>
                <div className="message-content">For your security, your session has timed out. Please sign in again to
                    continue.
                </div>
                <div className="buttons-section">
                    <Button
                        onClick={onClose}
                        variant="danger"
                        className="signed-out-button btn btn-danger"
                    >OK</Button>
                </div>
            </Modal.Body>
        </SignedOutStyleModal>
    );
};

export default SignedOutModal;
